import { getFormatLocale } from './getFormatLocale'

export const Formatters = {
  getFormatLocale,
}
